import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Contemporary_Period_-_Modern_Conflicts_e.g._Middle_East_Ukraine.png';

function HistoryPageModernConflictsGo() {
  return (
    <QuizPage
      title="History: Modern Conflicts"
      subTopic="Modern Conflicts (e.g., Middle East, Ukraine)"
      backgroundImage={historyImage}
      returnPath="/History-Modern-Conflicts"
    />
  );
}

export default HistoryPageModernConflictsGo;
